import { Text } from '@/components/ui/text';
import { cn } from '@/lib/utils';
import React from 'react';
import { View } from 'react-native';

interface ProfileStatsProps {
  checkInCount: number;
  friendsCount: number;
  mustTryCount: number;
}

interface StatProps {
  value: number;
  singular: string;
  plural: string;
  /** Optional emphasis for the value (e.g. coral for the Must Trys signal). */
  valueClassName?: string;
}

function Stat({ value, singular, plural, valueClassName }: StatProps) {
  const label = value === 1 ? singular : plural;
  return (
    <View
      className="items-center px-4"
      accessible
      accessibilityRole="text"
      accessibilityLabel={`${value} ${label}`}
    >
      <Text className={cn('text-xl font-bold text-foreground', valueClassName)}>{value}</Text>
      <Text className="text-sm text-muted-foreground">{label}</Text>
    </View>
  );
}

function Divider() {
  return <View testID="stat-divider" className="w-px self-center h-10 bg-border" />;
}

/**
 * A compact stat band under the profile header. Three counts held together by
 * hairline dividers so the row reads as one deliberate unit. "Must Trys" takes
 * the coral (`mustTry`) accent — the one place coral leads in the profile
 * summary, echoing the peak of the rating ladder.
 */
export function ProfileStats({ checkInCount, friendsCount, mustTryCount }: ProfileStatsProps) {
  return (
    <View className="flex-row items-stretch justify-center mb-4">
      <Stat value={checkInCount} singular="Check-in" plural="Check-ins" />
      <Divider />
      <Stat
        value={mustTryCount}
        singular="Must Try"
        plural="Must Trys"
        valueClassName="text-mustTry"
      />
      <Divider />
      <Stat value={friendsCount} singular="Friend" plural="Friends" />
    </View>
  );
}
